import React from "react";
import Link from "helpers/link";
import ArrowRight from "images/arrow-right-green.png";

const PageTrack = ({ paths }) => {
  return (
    <div className="flex items-center">
      {paths.map(({ name, path }, index) => (
        <React.Fragment key={index}>
          <Link
            to={path}
            className={`paragraph-normal ${
              index + 1 !== paths.length ? "text-green-800" : "text-gray-600"
            }`}
          >
            {name}
          </Link>
          {index + 1 !== paths.length && (
            <img
              src={ArrowRight}
              alt="arrow right"
              className="inline-block w-6 h-6 object-cover mr-2"
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PageTrack;
